import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Image from 'gatsby-image'

import { Row, Column } from '../components/grid'
import Layout from '../components/layout'
import Panel from '../components/panel'

import styles from './index.module.css'

import chromeLogo from '../images/chrome-logo.svg'

const IndexPage = ({ data }) => (
  <Layout>
    <Row>
      <Column size="six">
        <h1 className={styles.pageTitle}>
          Unslant is a nutritionist for your news diet.
        </h1>
        <p className={styles.pitch}>
          It’s dead simple: whenever you’re reading a news story, Unslant
          surfaces contrasting takes from outlets on the other side of the
          political spectrum, creating a more balanced news diet for you —
          without any intervention on your part.
        </p>
        <div className={styles.downloads}>
          <a
            href="https://chrome.google.com/webstore/detail/unslant/ghnfdehdiecemfacpmemnfkidagbibdo"
            className={styles.linkUnstyled}
          >
            <div className={styles.downloadButton}>
              <img
                src={chromeLogo}
                alt="Chrome icon"
                className={styles.downloadButtonIcon}
              />
              <div className={styles.downloadButtonCaption}>Add To Chrome</div>
            </div>
          </a>
        </div>
      </Column>
      <Column size="six">
        <div className={styles.panelWrapper}>
          <div>
            <Panel />
            <div style={{ textAlign: 'right', marginTop: 10 }}>
              <Image fixed={data.arrow.childImageSharp.fixed} />
            </div>
          </div>
        </div>
      </Column>
    </Row>
    <hr />
    <Row>
      <Column size="four">
        <Image
          fixed={data.outlets.childImageSharp.fixed}
          className={styles.featureImage}
        />
        <h2 className={styles.featureTitle}>400 outlets</h2>
        <p className={styles.featureBody}>
          Unslant supports 400 American news outlets from across the political
          spectrum. Support for other countries, including India, is planned.
        </p>
      </Column>
      <Column size="four">
        <Image
          fixed={data.design.childImageSharp.fixed}
          className={styles.featureImage}
        />
        <h2 className={styles.featureTitle}>Elegant design</h2>
        <p className={styles.featureBody}>
          Unslant is designed to be simple and elegant, surfacing only when
          there’s a high-quality suggestion available.
        </p>
      </Column>
      <Column size="four">
        <Image
          fixed={data.technology.childImageSharp.fixed}
          className={styles.featureImage}
        />
        <h2 className={styles.featureTitle}>Cutting-edge tech</h2>
        <p className={styles.featureBody}>
          Unslant is built on state-of-the-art AI and natural language
          processing models that analyze the story you’re reading to come up
          with a recommendation in seconds.
        </p>
      </Column>
    </Row>
  </Layout>
)
IndexPage.propTypes = {
  data: PropTypes.shape({
    technology: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        fixed: PropTypes.object,
      }),
    }),
    design: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        fixed: PropTypes.object,
      }),
    }),
    outlets: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        fixed: PropTypes.object,
      }),
    }),
    arrow: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        fixed: PropTypes.object,
      }),
    }),
  }).isRequired,
}

export const featureImage = graphql`
  fragment featureImage on File {
    childImageSharp {
      fixed(height: 150) {
        ...GatsbyImageSharpFixed_tracedSVG
      }
    }
  }
`

export const IndexQuery = graphql`
  query IndexQuery {
    technology: file(relativePath: { eq: "tech.png" }) {
      ...featureImage
    }
    design: file(relativePath: { eq: "lens.png" }) {
      ...featureImage
    }
    outlets: file(relativePath: { eq: "outlets.png" }) {
      ...featureImage
    }
    arrow: file(relativePath: { eq: "arrow.png" }) {
      childImageSharp {
        fixed(width: 180) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
  }
`

export default IndexPage
